var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "component-body full-size" }, [
    _c("nav", [
      _c(
        "ul",
        _vm._l(_vm.items, function(item) {
          return _c(
            "div",
            { key: item.id },
            [
              _vm.mostrarMenu(item.permissao) ||
              item.permissao === "CAIXA_PROCESSO"
                ? _c(
                    "el-tooltip",
                    {
                      attrs: {
                        id: "tooltip",
                        effect: "dark",
                        content: item.nome.split("_")[0],
                        disabled:
                          item.nome.length < 26 && _vm.windowWidth > 1365,
                        placement: "right"
                      }
                    },
                    [
                      _c(
                        "li",
                        {
                          staticClass: "menu-item",
                          class: {
                            active: _vm.$route.meta.routeGroup == item.routeName
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.goTo(item.routeName)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "menu-group",
                              attrs: { id: "menu-side-" + item.routeName }
                            },
                            [
                              item.icon.includes("img")
                                ? _c("span", [
                                    _c("img", {
                                      staticClass: "iconeImg",
                                      attrs: {
                                        src: _vm.buscarIcone(
                                          item.icon.split("-")[0]
                                        ),
                                        alt: "icone"
                                      }
                                    })
                                  ])
                                : _c("font-awesome-icon", {
                                    attrs: { icon: item.icon }
                                  }),
                              item.nome.split("_")[0].length > 25
                                ? _c("div", { staticClass: "menu-text" }, [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          item.nome.split("_")[0].slice(0, 25)
                                        ) + "..."
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              item.nome.length <= 25
                                ? _c("div", { staticClass: "menu-text" }, [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          item.nome.split("_")[0].slice(0, 25)
                                        )
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e1ddf1a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e1ddf1a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideMenuLazy.vue
// module id = null
// module chunks = 